
const data = {
  respuesta: {
    IDInterno: 23224,
    Tipo: {
      Tipo: null
    },
    Asunto: '',
    Empresa: 'FRAGADIS',
    Organismo: 'Tesorería General de la Seguridad Social',
    Sede: {
      Id: 0,
      Sede: null
    },
    IdPGN: 2,
    Estado: {
      Id: 0,
      Estado: 'Puesta a disposición'
    },
    FechaDisposicion: '2021-11-23T23:14:00',
    FechaDescarga: '1998-12-31T23:00:00',
    MetadatosAdicionales: [],
    Adjuntos: [],
    DocumentosRelacionados: []
  },
  blnError: false,
  codError: null,
  msgError: null
}

export default data
